module.exports = __webpack_public_path__ + "img/weixin-qrcode.84aad0e6.png";